import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=2bea805f&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.vue?vue&type=style&index=0&id=2bea805f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea805f",
  null
  
)

export default component.exports